/* eslint-disable indent */
import React from 'react';
import classNames from 'classnames';
import { makeStyles, Paper } from '~/lib/bn-material-ui';
import { useOrdersDialogStateSelector } from '../context/orders-dialog-context';
import { OrderIcon } from '../../../components/order-icon';
import { getOrderStateText } from '../../../components/order-state-text';
import { isOrderLate } from '~/orders/order-helpers';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  container: {
    display: 'flex',
    gap: '.25em',
    marginBottom: '.5rem',
    padding: '.25rem .5rem',
    [breakpoints.down('sm')]: {
      display: 'none',
    },
    '&.ready': {
      color: palette.yellow[30],
      background: palette.yellow[10],
    },
    '&.draft': {
      color: palette.orange[30],
      background: palette.orange[10],
    },
    '&.scheduled': {
      color: palette.blue[60],
      background: palette.blue[10],
    },
    '&.delivered': {
      color: palette.green[30],
      background: palette.green[10],
    },
    '&.late': {
      color: palette.yellow[30],
      background: palette.yellow[10],
    },
    '&.not-delivered': {
      color: palette.red[30],
      background: palette.red[10],
    },
  },
  icon: {
    fontSize: '1.4em',
  },
}));

function getContainerClassAndDisplayText(orderEntity) {
  const { state } = orderEntity.properties;
  const isLate = isOrderLate(orderEntity);
  const displayText = getOrderStateText({ state, isLate });

  if (state === 'delivered') {
    return {
      className: 'delivered',
      displayText,
    };
  }

  if (state === 'not-delivered') {
    return {
      className: 'not-delivered',
      displayText,
    };
  }

  if (isLate) {
    return {
      className: 'late',
      displayText,
    };
  }

  if (state === 'ready') {
    return {
      className: 'ready',
      displayText,
    };
  }

  if (state === 'draft') {
    return {
      className: 'draft',
      displayText,
    };
  }

  if (state === 'scheduled') {
    return {
      className: 'scheduled',
      displayText,
    };
  }

  return {};
}

export function OrdersDialogStateBanner() {
  const styles = useStyles();
  const [selectedOrderEntity] = useOrdersDialogStateSelector(['selectedOrderEntity']);
  if (!selectedOrderEntity) {
    return null;
  }

  const { className, displayText } = getContainerClassAndDisplayText(selectedOrderEntity);
  if (!displayText) {
    return null;
  }

  return (
    <Paper elevation={0} className={classNames(styles.container, className)}>
      <OrderIcon orderEntity={selectedOrderEntity} className={styles.icon} /> {displayText}
    </Paper>
  );
}
